import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestWarehouseReport, clearWarehouseReport } from 'actionCreators';
import { getWorkroomById } from '../../../../../reducers';
import PageActionBar from 'components/PageActionBar';
import ReportFilters from 'ReportFilters';
import ReportHeaders from 'ReportHeaders';
import WarehouseSummaryTable from 'WarehouseSummaryTable';
import contentAreaStyles from 'styles/contentArea';
import S from 'styles.scss';

class WarehouseReport extends React.Component {
  componentDidMount() {
    this.props.clearWarehouseReport();
    if (this.props.location.search) {
      this.props.requestWarehouseReport(this.props.location.query);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      if (nextProps.location.search) {
        this.props.requestWarehouseReport(nextProps.location.query);
      } else {
        this.props.clearWarehouseReport();
      }
    }
  }

  componentWillUnmount() {
    this.props.clearWarehouseReport();
  }

  render() {
    const { location, report: { loaded } } = this.props;
    return (
      <div>
        <PageActionBar
          showAdd={false}
          showFiltersBtn={false}
          title="Warehouse Report"
        />
        <div className={contentAreaStyles.contentAreaContainer}>
          <div className={`${contentAreaStyles.contentArea} ${S.noPrint}`}>
            <ReportFilters location={location} />
          </div>
          {loaded &&
            <div className={`${contentAreaStyles.contentArea} ${S.tableContainer}`}>
              <ReportHeaders workroom={location.query.workroom_id} />
              <WarehouseSummaryTable />
            </div>
          }
        </div>
      </div>
    );
  }
}

WarehouseReport.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.shape({
    loaded: PropTypes.bool,
  }),
  requestWarehouseReport: PropTypes.func.isRequired,
  clearWarehouseReport: PropTypes.func.isRequired,
};

export default connect((state, ownProps) => ({
  report: state.reports.warehouse,
  workroom: getWorkroomById(state)(ownProps.location.query.workroom_id),
}), { requestWarehouseReport, clearWarehouseReport })(WarehouseReport);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/warehouse/index.jsx